import type { IUser } from "@/interfaces/user";
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
export interface AppSliceI {
  user?: IUser;
  redirectTo?: string;
  token?: string;
  lassoToken?: string;
  loading?: boolean;
}

const initialState: AppSliceI = {
  loading: false,
  token: undefined,
  lassoToken: undefined,
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setAppStateAction(state: AppSliceI, action: PayloadAction<AppSliceI>) {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetApp() {
      return initialState;
    },
  },
});

export default appSlice.reducer;
export const { setAppStateAction } = appSlice.actions;
